import React from 'react';
import PropTypes from 'prop-types';
import { Message, Icon } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * UIMessage
 * Display the react semantic component Message with the selected mode (DARK or LIGHT)
 * Props (parameters)
 * @param bool attached
 * @param string icon: icon name
 * @param string header
 * @param string content
 * @param array list
 * @param string mode
 */
export default class UiMessage extends React.PureComponent {
  render() {
    const { attached, icon, header, mode, content, list } = this.props;
    const styleMessage = {};
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      styleMessage.color = colors.MESSAGE_COLOR;
      styleMessage.backgroundColor = colors.MESSAGE_BACKGROUND_COLOR;
      styleMessage.borderColor = colors.MESSAGE_BORDER_COLOR;
    }
    if (!list || list.length === 0) {
      return (
        <Message
          attached={attached}
          icon={icon}
          header={header}
          style={styleMessage}
          content={content}
        />
      );
    }
    const iconView = icon ? <Icon name={icon} /> : null;
    return (
      <Message attached={attached} style={styleMessage} className="ui-message">
        {header && (
          <Message.Header>
            {iconView}
            {header}
          </Message.Header>
        )}
        {content && (
          <Message.Content>
            {!header && iconView}
            {content}
          </Message.Content>
        )}
        {!header && !content && iconView}
        {list && list.length > 0 && (
          <div className="uimessage-list">
            <Message.List>
              {list.map((l) => (
                <Message.Item>{l}</Message.Item>
              ))}
            </Message.List>
          </div>
        )}
      </Message>
    );
  }
}

UiMessage.propTypes = {
  attached: PropTypes.bool,
  icon: PropTypes.string,
  header: PropTypes.string,
  content: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.string),
  mode: PropTypes.string,
};

UiMessage.defaultProps = {
  attached: false,
  icon: null,
  header: '',
  content: '',
  mode: null,
  list: [],
};
